import { render, staticRenderFns } from "./tabs_index.vue?vue&type=template&id=4019f7b8&scoped=true"
import script from "./tabs_index.vue?vue&type=script&lang=js"
export * from "./tabs_index.vue?vue&type=script&lang=js"
import style0 from "./tabs_index.vue?vue&type=style&index=0&id=4019f7b8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4019f7b8",
  null
  
)

export default component.exports